import $ from 'jquery';

export default class Video {
    constructor() {
        $(".js-video__poster").on('click', function() {
            const $video = $(this).closest('.js-video').find('.js-video__video iframe');

            $(this).fadeOut();

            // Check for querystring existence
            const symbol = $video[0].src.indexOf("?") > -1 ? "&" : "?";

            // Modify source to autoplay and start video
            $video[0].src += symbol + "autoplay=1";
        });
    };
};
